import { Path } from "@/navigations/routes";

export const checkTextWhite = (pathname: string) => {
  const whiteTextPath: string[] = [Path.License];

  return whiteTextPath.includes(pathname);
};
